import { subscribeToNewsletter as subscribeToNewsletterService } from '@core/services/newsletter/newsletter-service'
import { CoreError, CoreErrorCause } from '@domain/models/core-error'
import type { CreateNewsletterSubscriptionInput } from '@domain/models/newsletter'

export class NewsletterFeature {
  public static async subscribe(
    input: CreateNewsletterSubscriptionInput,
  ): Promise<string> {
    try {
      return await subscribeToNewsletterService(input)
    } catch (error) {
      if (error instanceof CoreError) {
        throw error
      }
      throw new CoreError({
        cause: CoreErrorCause.Unknown,
        context: 'Failed to process newsletter subscription.',
        underlyingException: error,
      })
    }
  }
}

export async function subscribeToNewsletter(
  input: CreateNewsletterSubscriptionInput,
): Promise<string> {
  return NewsletterFeature.subscribe(input)
}
